import { useaxios } from "../../../../utils/useaxios";
export default (from, to) => initDispatch => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    useaxios('radio_income/read.php', { from, to }).then((res) => {
        if (res.status == "ok") {
            initDispatch({ type: 'setincome', payload: res.income });
        } else {
            // clear();
        }
        // setloading(false);
    });
}